import React, { useContext, useEffect } from 'react';
import GanttChart from './GanttChart'; // Upewnij się, że ścieżka jest poprawna
import { TechnologyContext } from 'context/TechnologyContext';
import { useGant } from './useGant';
import axios from "axios";
import { IP } from "../../utils/Host";
import { useNavigate } from "react-router-dom";
import GanttChartAll from './GanttChartAll';
import GantMulti from './GantMulti';


function GantAll26multi() {
    const techContext = useContext(TechnologyContext);
  const gantStageGrupy = techContext.gantStageGrupy;
  const navigate = useNavigate();

    const {refreshGant,refreshGantAll} = useGant();

  async function checkToken() {
    axios
      .get(IP + "/islogged/" + sessionStorage.getItem("token"))
      .then((res) => {
        if (res.data.Status === "Success") {
      refreshGantAll()

        } else {
          navigate("/Login");
        }
      });
  }

  useEffect(() => {
    checkToken();

  }, []);



  if(gantStageGrupy){
      return (
    <div className="App">
      {/* <GanttChart stages={gantStageGrupy} /> */}
      {/* <GanttChartAll stages={gantStageGrupy} /> */}
      {/* <GanttChart /> */}



      {/* <GanttChartAll stages={gantStageGrupy} />   */}
      <GantMulti stages={gantStageGrupy} />  
    </div>
  );
  }

}

export default GantAll26multi;